<html>
  <head>
    <meta name="robots" content="noindex" />
  </head>

  <body>
    <div class="body">
      <div *ngIf="cargado" class="container">
        <!-- Botones de acción -->
        <div class="botones text-center my-4">
          <button (click)="abrirDialogActualizarContrasena(true)" class="boton">
            Actualizar contraseña
          </button>
          <button (click)="abrirDialogBorrarUsuario()" class="boton borrar_usuario">
            Eliminar usuario
          </button>
        </div>

        <!-- Formulario -->
        <mat-card>
          <form [formGroup]="form" (ngSubmit)="saveData()" novalidate>
            <div class="row">

              <!-- Email -->
              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 p-2">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Email</mat-label>
                  <input (input)="hayModificacion()" matInput formControlName="email" autocomplete="off" />
                  <mat-error *ngIf="getForm.email.invalid">{{ getErrorMessageEmail() }}</mat-error>
                </mat-form-field>
              </div>
              
              <!-- Foto de perfil -->
              <div class="col-xl-8 col-12 p-2">
                <div class="row align-items-center mb-1">
                  <div class="col-auto">
                    <label for="fotoPerfil" class="form-label mb-0">Foto de perfil:</label>
                    <mat-hint class="d-block">Max. 10 MB</mat-hint>
                  </div>
                  <div class="col-auto d-flex align-items-center gap-2">
                    <label
                      class="btn btn-outline-primary d-flex align-items-center gap-2 mb-0"
                      [class.disabled]="loading"
                    >
                    📷 Subir foto
                      <input
                        (input)="hayModificacion()"
                        [disabled]="loading"
                        type="file"
                        (change)="onFileChange($event)"
                        accept="image/*, .heic"
                        id="fotoPerfil"
                        class="form-control"
                        hidden
                      />
                    </label>
                    <i *ngIf="nombreArchivo" class="bi bi-check-circle-fill text-success ml-2"></i>
                  </div>
                </div>
                <div *ngIf="nombreArchivo" class="text-muted small mt-1">
                  {{ nombreArchivo }}
                </div>
              
                <div *ngIf="getForm.fotoPerfil.errors" class="invalid-feedback d-block mt-1">
                  <div *ngIf="getForm.fotoPerfil.errors.archivoInvalido">
                    Solo se admiten imágenes
                  </div>
                </div>
              </div>
              <!-- Foto de perfil viejo (queda por si el nuevo falla)
              <div class="col-xl-8 col-12 p-2">
                <label for="fotoPerfil">Foto de perfil</label>
                <input
                  (input)="hayModificacion()"
                  [disabled]="loading"
                  type="file"
                  (change)="onFileChange($event)"
                  accept="image/*, .heic"
                  id="fotoPerfil"
                  class="form-control"
                />
                <mat-hint>Max. 10 MB</mat-hint>
                <div *ngIf="getForm.fotoPerfil.errors" class="invalid-feedback">
                  <div *ngIf="getForm.fotoPerfil.errors.archivoInvalido">
                    Solo se admiten imágenes
                  </div>
                </div>
              </div> -->

              <!-- Celular -->
              <div class="col-12 my-2">
                <p *ngIf="tieneCargadoCelular()">
                  Su número de celular actual es:
                  <b>{{ userData.telefonoParticular }}</b>,
                  en caso de modificarlo, recuerde
                  <b class="text-danger">verificarlo</b>.
                </p>
                <p *ngIf="!tieneCargadoCelular()">
                  Celular: <b class="text-danger">Recuerde verificarlo para continuar</b>
                </p>
                <app-phone-form (numeroFinal)="numeroFinal($event)"></app-phone-form>
              </div>

              <!-- Fecha de nacimiento -->
              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 p-2">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Fecha de nacimiento</mat-label>
                  <input
                    (input)="hayModificacion()"
                    formControlName="fechaNacimiento"
                    matInput
                    [max]="fecha_max"
                    [matDatepicker]="nuevaFecha"
                  />
                  <mat-error *ngIf="getForm.fechaNacimiento.invalid">
                    {{ getErrorMessageFechaNac() }}
                  </mat-error>
                  <mat-datepicker-toggle matSuffix [for]="nuevaFecha" (click)="hayModificacion()"></mat-datepicker-toggle>
                  <mat-datepicker #nuevaFecha></mat-datepicker>
                </mat-form-field>
              </div>

              <!-- Domicilio -->
              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 p-2">
                <mat-form-field appearance="outline" class="w-100" hintLabel="Máx. 40 caracteres">
                  <mat-label>Domicilio</mat-label>
                  <input
                    (input)="hayModificacion()"
                    autocomplete="off"
                    matInput
                    #inputDomicilio
                    maxlength="40"
                    formControlName="domicilio"
                    id="inputDomicilio"
                  />
                  <mat-error *ngIf="getForm.domicilio.invalid">
                    {{ getErrorMessageDomicilio() }}
                  </mat-error>
                  <mat-hint align="end">{{ inputDomicilio.value?.length || 0 }}/40</mat-hint>
                </mat-form-field>
              </div>

              <!-- Localidad -->
              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 p-2">
                <mat-form-field appearance="outline" class="w-100" hintLabel="Máx. 25 caracteres">
                  <mat-label>Localidad</mat-label>
                  <input
                    (input)="hayModificacion()"
                    matInput
                    autocomplete="off"
                    #inputLocalidad
                    maxlength="25"
                    formControlName="localidad"
                  />
                  <mat-error *ngIf="getForm.localidad.invalid">
                    {{ getErrorMessageLocalidad() }}
                  </mat-error>
                  <mat-hint align="end">{{ inputLocalidad.value?.length || 0 }}/25</mat-hint>
                </mat-form-field>
              </div>

              <!-- Código postal -->
              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 p-2">
                <mat-form-field appearance="outline" class="w-100" hintLabel="Máx. 4 caracteres">
                  <mat-label>Código postal</mat-label>
                  <input
                    (input)="hayModificacion()"
                    matInput
                    autocomplete="off"
                    #inputCP
                    maxlength="4"
                    formControlName="cp"
                  />
                  <mat-error *ngIf="getForm.cp.invalid">
                    {{ getErrorMessageCP() }}
                  </mat-error>
                  <mat-hint align="end">{{ inputCP.value?.length || 0 }}/4</mat-hint>
                </mat-form-field>
              </div>

              <!-- Botón de confirmación -->
              <div class="col-12 d-flex justify-content-center mt-4">
                <button
                  mat-raised-button
                  type="submit"
                  class="boton"
                  (click)="submit"
                  [disabled]="loadingSubmit || !hay_modificacion || formularioInvalido()"
                  [class.spinnerButton]="loadingSubmit"
                >
                  Confirmar
                </button>
              </div>

            </div>
          </form>
        </mat-card>
      </div>
    </div>
  </body>
</html>
